// Shared design tokens, kept in sync with the Flutter app's lib/theme.dart
// so the web store and mobile delivery app look and feel consistent.
// The canonical values live as CSS custom properties in src/index.css —
// this module mirrors them for the rare spot that needs a JS value
// (charts, inline canvas drawing, etc.) rather than a CSS class.

export const colors = {
  primary: '#F2B922',
  primaryDark: '#D9A30F',
  secondary: '#2E7D32',
  background: '#FFFFFF',
  surface: '#F6F4EF',
  error: '#D32F2F',
  textPrimary: '#1A1A1A',
  textSecondary: '#6E6E6E',
  border: '#E0E0E0',
};

export const statusColors = {
  RECEIVED: { fg: '#2F6FED', bg: '#EAF1FE', label: 'Received' },
  CONFIRMED: { fg: '#B8850A', bg: '#FDF2D3', label: 'Confirmed' },
  PACKED: { fg: '#7C3AED', bg: '#F2EBFE', label: 'Packed' },
  OUT_FOR_DELIVERY: { fg: '#0D9488', bg: '#E3F6F4', label: 'Out for delivery' },
  DELIVERED: { fg: '#2E7D32', bg: '#E3F1E4', label: 'Delivered' },
  FAILED: { fg: '#D32F2F', bg: '#FBE9E9', label: 'Failed' },
  FAILED_DELIVERY: { fg: '#D32F2F', bg: '#FBE9E9', label: 'Failed delivery' },
  CANCELLED: { fg: '#6E6E6E', bg: '#F0F0F0', label: 'Cancelled' },
  REQUESTED: { fg: '#B8850A', bg: '#FDF2D3', label: 'Pending review' },
  REJECTED: { fg: '#D32F2F', bg: '#FBE9E9', label: 'Rejected' },
  APPROVED: { fg: '#2E7D32', bg: '#E3F1E4', label: 'Approved' },
  OPEN: { fg: '#2F6FED', bg: '#EAF1FE', label: 'Open' },
  IN_PROGRESS: { fg: '#B8850A', bg: '#FDF2D3', label: 'In progress' },
  CLOSED: { fg: '#2E7D32', bg: '#E3F1E4', label: 'Closed' },
  QUEUED: { fg: '#6E6E6E', bg: '#F0F0F0', label: 'Queued' },
  RUNNING: { fg: '#B8850A', bg: '#FDF2D3', label: 'Running' },
  READY: { fg: '#2E7D32', bg: '#E3F1E4', label: 'Ready' },
  PENDING: { fg: '#B8850A', bg: '#FDF2D3', label: 'Pending' },
  PAID: { fg: '#2E7D32', bg: '#E3F1E4', label: 'Paid' },
  COLLECTED: { fg: '#2E7D32', bg: '#E3F1E4', label: 'Paid' },
  OUT: { fg: '#0D9488', bg: '#E3F6F4', label: 'Out' },
  SKIPPED: { fg: '#6E6E6E', bg: '#F0F0F0', label: 'Skipped' },
};

export const fontFamily = "'IBM Plex Sans', sans-serif";
export const fontMono = "'IBM Plex Mono', monospace";

// Mirrors AppTextStyles in the Flutter theme (greaterHeading, heading1-5, body1-3).
export const textStyles = {
  greaterHeading: { fontFamily, fontSize: 32, fontWeight: 700, lineHeight: 1.2 },
  heading1: { fontFamily, fontSize: 24, fontWeight: 700, lineHeight: 1.25 },
  heading2: { fontFamily, fontSize: 18, fontWeight: 700, lineHeight: 1.4 },
  heading3: { fontFamily, fontSize: 14, fontWeight: 700, lineHeight: 1.4 },
  heading4: { fontFamily, fontSize: 14, fontWeight: 500, lineHeight: 1.4 },
  heading5: { fontFamily, fontSize: 14, fontWeight: 700, lineHeight: 1.2 },
  body1: { fontFamily, fontSize: 14, fontWeight: 400, lineHeight: 1.5 },
  body2: { fontFamily, fontSize: 12, fontWeight: 400, lineHeight: 1.5 },
  body3: { fontFamily, fontSize: 12, fontWeight: 400, lineHeight: 1.5 },
};

const theme = { colors, statusColors, fontFamily, fontMono, textStyles };

export default theme;
